import { render, staticRenderFns } from "./videoSetting.vue?vue&type=template&id=dd26974e&"
import script from "./videoSetting.vue?vue&type=script&lang=js&"
export * from "./videoSetting.vue?vue&type=script&lang=js&"
import style0 from "./videoSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports